module.exports = __webpack_public_path__ + "img/clement-mirror.b44e9c66.png";